module.exports = __webpack_public_path__ + "static/tp-feature-1-fa1eb739cec5354a431222e2a67a472e.png";